import ROUTES from "~/kernel/routing/ROUTES";
import Breadcrumb from "~/ui/Breadcrumb";
import { useLoaderData } from "@remix-run/react";
import useTranslation from "~/kernel/internationalization/useTranslation";
import type { LoaderData } from "./route";

export function NewReviewBreadcrumb() {
  const { company } = useLoaderData<LoaderData>();
  const { getScopedT } = useTranslation();
  return (
    <Breadcrumb
      links={[
        {
          to: ROUTES.company.path({ params: { slug: company.slug } }),
          text: company.name,
        },
        {
          to: ROUTES.newReview.path({ params: { slug: company.slug } }),
          text: getScopedT("new")("pageTitle"),
        },
      ]}
    />
  );
}
